/*! @pentacode/ui v0.1.0 */
import { C as e, b as t, d as n, f as r, g as i, h as a, l as o, m as s, p as c, u as l, v as u, x as d } from "./guide-layout-CM2GPEJu.js";
import { i as f, n as p, r as m, t as h } from "./rule-BbeXdbtC.js";
import { r as g } from "./scene-8VKOJsMP.js";
import { t as _ } from "./mark-with-scale-values-_R2jS0ZJ.js";
import { t as v } from "./stack-Bwmp8HrU.js";
import { n as y, t as b } from "./mark-decorative-B0-tbEeT.js";
import { formatDay as x } from "./charts/format.js";
import { i as S, r as C, t as w } from "./theme-BDdgxk0M.js";
import { a as T, c as E, d as D, i as O, l as k, o as A, r as j, s as M, u as N } from "./shared-CfvkKPnq.js";
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/area.js
function P(e, a = {}) {
	let l = Array.isArray(e) ? e : Array.from(e), p = a.xScale ?? "x", m = a.yScale ?? "y";
	return n(({ markIndex: e }) => {
		let n = a.id ?? `area-y-${e}`, h = o(l, a.x, (e, { index: t }) => t), g = a.y ?? a.y2, _ = typeof g == "number" ? l.map(() => g) : o(l, g, (e) => typeof e == "number" ? e : void 0), v = o(l, a.z, () => null), y = a.color === void 0 ? v : o(l, a.color, () => null), b = a.z === void 0 && a.color !== void 0 ? y : v, x = a.y1 !== void 0 || a.y2 !== void 0;
		if (x && a.layout) throw TypeError("An area with explicit y1 or y2 endpoints cannot also configure a stack layout");
		let S = x ? void 0 : f(h, _, b, a.layout), C = x ? typeof a.y1 == "number" ? l.map(() => a.y1) : o(l, a.y1, () => 0) : S.starts, w = x ? typeof a.y2 == "number" ? l.map(() => a.y2) : o(l, a.y2 ?? a.y, () => void 0) : S.ends, T = r(l, a.key, {
			groups: b,
			candidates: [h],
			markId: n,
			warningIdentity: a
		}), E = /* @__PURE__ */ new Map();
		return b.forEach((e, t) => {
			let n = d(e ?? null), r = E.get(n);
			r ? r.push(t) : E.set(n, [t]);
		}), {
			id: n,
			states: i(l, a.states),
			seriesFromColor: a.z === void 0 && a.color !== void 0,
			channels: {
				x: {
					scale: p,
					values: h.filter(c)
				},
				y: {
					scale: m,
					values: [...w.filter(s), ...C.filter(s)],
					includeZero: a.y1 === void 0
				},
				color: {
					scale: "color",
					values: y.filter(t)
				}
			},
			render: ({ scales: e, color: t }) => {
				let r = [];
				for (let [i, o] of E) {
					let f = o[0];
					if (f === void 0) continue;
					let g = b[f] ?? null, v = l[f], x = t(y[f] ?? null), S = u(a.fill, v, f, l, x), E = a.stroke === void 0 ? void 0 : u(a.stroke, v, f, l, x), D = [], O = [], k = [], A = 0, j = () => {
						if (!D.length) return;
						let e = [...O].reverse(), t = a.curve?.area(D, O);
						r.push({
							kind: "area",
							key: `${n}:${i}:segment:${A}`,
							points: [...D, ...e],
							path: t,
							interaction: {
								points: k,
								affinity: "x"
							},
							style: {
								fill: S,
								fillOpacity: a.fillOpacity ?? .2,
								stroke: E,
								strokeWidth: a.strokeWidth
							}
						}), D = [], O = [], k = [], A += 1;
					};
					for (let t of o) {
						let r = h[t], a = _[t], o = C[t], u = w[t];
						if (!c(r) || !s(a) || !s(o) || !s(u)) {
							j();
							continue;
						}
						let f = e[p].map(r), v = e[m].map(u);
						D.push([f, v]), O.push([f, e[m].map(o)]);
						let y = {
							key: `${n}:${i}:${d(T[t])}`,
							markId: n,
							group: g,
							groupLabel: g == null ? n : String(g),
							datum: l[t],
							datumIndex: t,
							xValue: r,
							yValue: a,
							y1Value: o,
							y2Value: u,
							yInterval: "difference",
							x: f,
							y: v,
							color: S
						};
						k.push(y);
					}
					j();
				}
				return { nodes: [{
					kind: "group",
					key: n,
					className: "ts-chart__area",
					ariaHidden: !0,
					children: r
				}] };
			}
		};
	}, a.motion, a.renderer);
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/dot-layout.js
var F = /* @__PURE__ */ Symbol("resolveDotLayout");
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/resolved-layout-position.js
function I(e, t, n) {
	return R(e, t, n, "xValue", "x");
}
function L(e, t, n) {
	return R(e, t, n, "yValue", "y");
}
function R(e, t, n, r, i) {
	return e.flatMap((e) => {
		let a = t[e.sourceIndex];
		if (!c(a)) return [];
		let o = n.map(a);
		return Number.isFinite(o) ? [{
			...e,
			[r]: a,
			[i]: o
		}] : [];
	});
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/dot.js
function z(n, s = {}) {
	let u = Array.isArray(n) ? n : Array.from(n), f = s.xScale ?? "x", p = s.yScale ?? "y";
	return _(({ markIndex: n }) => {
		let m = s.id ?? `dot-${n}`, h = s.layout;
		if (h?.axis === "x" && s.x !== void 0) throw TypeError("dot: x is derived by its layout and cannot be configured");
		if (h?.axis === "y" && s.y !== void 0) throw TypeError("dot: y is derived by its layout and cannot be configured");
		let g = h?.axis === "x" ? u.map(() => h.anchor) : o(u, s.x, (e, { index: t }) => t), _ = h?.axis === "y" ? u.map(() => h.anchor) : o(u, s.y, (e) => typeof e == "number" ? e : void 0), v = o(u, s.z, () => null), y = s.color === void 0 ? v : o(u, s.color, () => null), b = r(u, s.key, {
			groups: v,
			candidates: h?.axis === "x" ? [_] : h?.axis === "y" ? [g] : [
				g,
				_,
				l(g, _)
			],
			markId: m,
			warningIdentity: s
		}), x = typeof s.r == "number" ? u.map(() => s.r) : o(u, s.r, () => 3.5), S = e(s.rScale, x), C = S ? x.map((e) => a(e) ? S(e) : NaN) : x, w = u.map((e, t) => ({
			datum: e,
			sourceIndex: t
		})), T = (e, t) => {
			let n = [];
			return e.forEach((e) => {
				let { datum: r, sourceIndex: i, xValue: o, yValue: c, x: l, y: u } = e, f = C[i];
				if (!a(f)) return;
				let p = v[i] ?? null, g = d(p), _ = s.fill ?? t(y[i] ?? null), x = `${m}:${g}:${d(b[i])}`, S = {
					key: x,
					markId: m,
					group: p,
					groupLabel: p == null ? m : String(p),
					datum: r,
					datumIndex: i,
					xValue: o,
					yValue: c,
					x: l,
					y: u,
					color: _
				};
				n.push({
					kind: "dot",
					key: x,
					x: l,
					y: u,
					radius: f,
					interaction: {
						point: S,
						affinity: h?.axis === "y" ? "x" : h?.axis === "x" ? "y" : void 0
					},
					style: {
						fill: _,
						fillOpacity: s.fillOpacity,
						stroke: s.stroke,
						strokeOpacity: s.strokeOpacity,
						strokeWidth: s.strokeWidth
					}
				});
			}), { nodes: [{
				kind: "group",
				key: m,
				className: "ts-chart__dot",
				ariaHidden: !0,
				children: n
			}] };
		}, E = {
			...h?.axis === "x" ? {} : { x: {
				scale: f,
				values: g.filter(c)
			} },
			...h?.axis === "y" ? {} : { y: {
				scale: p,
				values: _.filter(c)
			} },
			color: {
				scale: "color",
				values: y.filter(t)
			}
		}, D = {
			id: m,
			seriesFromColor: s.z !== void 0 && s.color === void 0,
			states: i(u, s.states),
			channels: E
		};
		return h ? {
			...D,
			resolveLayout: ({ chart: e, scales: t }) => {
				if (h.axis === "y") {
					let n = I(w, g, B(t[f], f)).filter((e) => a(C[e.sourceIndex])), r = V(h, e, n.map((e) => e.x), n.map((e) => C[e.sourceIndex])), i = n.map((e, t) => ({
						...e,
						yValue: h.anchor,
						y: r[t]
					}));
					return { render: ({ color: e }) => T(i, e) };
				}
				let n = L(w, _, B(t[p], p)).filter((e) => a(C[e.sourceIndex])), r = V(h, e, n.map((e) => e.y), n.map((e) => C[e.sourceIndex])), i = n.map((e, t) => ({
					...e,
					xValue: h.anchor,
					x: r[t]
				}));
				return { render: ({ color: e }) => T(i, e) };
			}
		} : {
			...D,
			render: ({ scales: e, color: t }) => {
				let n = B(e[f], f), r = B(e[p], p), i = L(I(w, g, n), _, r);
				return T(i, t);
			}
		};
	}, s.motion, s.renderer);
}
function B(e, t) {
	if (!e) throw TypeError(`dot: missing ${t} scale`);
	return e;
}
function V(e, t, n, r) {
	let i = e[F]({
		chart: t,
		measuredPositions: n,
		radii: r
	});
	if (i.length !== n.length || i.some((e) => !Number.isFinite(e))) throw TypeError("dot: layout must resolve one finite position per row");
	return i;
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/focus-mark.js
function H(e, t = {}) {
	return {
		...e,
		initialize(n) {
			return {
				...e.initialize(n),
				focus: t
			};
		}
	};
}
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/text.js
function U(e, a = {}) {
	let s = Array.isArray(e) ? e : Array.from(e), f = a.xScale ?? "x", p = a.yScale ?? "y";
	return n(({ markIndex: e }) => {
		let n = a.id ?? `text-${e}`, m = o(s, a.x, (e, { index: t }) => t), h = o(s, a.y, (e) => typeof e == "number" ? e : void 0), g = o(s, a.text, (e) => e == null ? "" : String(e)), _ = o(s, a.z, () => null), v = a.color === void 0 ? _ : o(s, a.color, () => null), y = r(s, a.key, {
			groups: _,
			candidates: [
				m,
				h,
				l(m, h)
			],
			markId: n,
			warningIdentity: a
		}), b = s.map((e, t) => u(a.anchor, e, t, s, "middle")), x = s.map((e, t) => u(a.dx, e, t, s, 0)), S = s.map((e, t) => u(a.dy, e, t, s, 0)), C = a.rotate === void 0 ? void 0 : s.map((e, t) => u(a.rotate, e, t, s, 0)), w = (e, t) => {
			let r = m[t], i = h[t], o = g[t];
			if (!c(r) || !c(i) || o == null) return;
			let s = _[t] ?? null, l = v[t] ?? null;
			return {
				node: {
					kind: "label",
					key: `${n}:${d(s)}:${d(y[t])}`,
					x: e.scales[f].map(r) + (x[t] ?? 0),
					y: e.scales[p].map(i) + (S[t] ?? 0),
					text: String(o),
					anchor: b[t],
					baseline: "middle",
					rotate: C?.[t],
					fontSize: a.fontSize,
					fontWeight: a.fontWeight
				},
				xValue: r,
				yValue: i,
				group: s,
				colorValue: l
			};
		};
		return {
			id: n,
			states: i(s, a.states),
			channels: {
				x: {
					scale: f,
					values: m.filter(c)
				},
				y: {
					scale: p,
					values: h.filter(c)
				},
				color: {
					scale: "color",
					values: v.filter(t)
				}
			},
			layoutLabels: (e) => s.flatMap((t, n) => {
				let r = w(e, n);
				return r ? [r.node] : [];
			}),
			render: (e) => {
				let { theme: t, color: r } = e, i = [], o = [];
				return s.forEach((c, l) => {
					let d = w(e, l);
					if (!d) return;
					let { node: f, xValue: p, yValue: m, group: h, colorValue: g } = d, _ = u(a.fill, c, l, s, g == null ? t.foreground : r(g));
					i.push({
						...f,
						style: { fill: _ }
					}), o.push({
						key: f.key,
						markId: n,
						group: h,
						groupLabel: h == null ? n : String(h),
						datum: c,
						datumIndex: l,
						xValue: p,
						yValue: m,
						x: f.x,
						y: f.y,
						color: _
					});
				}), {
					nodes: [{
						kind: "group",
						key: n,
						className: "ts-chart__text",
						ariaHidden: !0,
						children: i
					}],
					points: o
				};
			}
		};
	}, a.motion, a.renderer);
}
// src/charts/presets/line.ts
function W(e, t, n) {
	let r = n ?? (A(e) ? x : M);
	return S({ items: [{
		id: "x",
		label: "",
		text: (e) => r(e.xValue)
	}, {
		channel: "y",
		label: "",
		text: (e) => t(e.yValue)
	}] });
}
var G = "area-threshold", K = .3;
function q({ value: e, below: t, above: n }, r) {
	let i = r.map((e) => e.value), a = Math.min(0, ...i), o = Math.max(0, ...i), s = o > a ? (e - a) / (o - a) : 1;
	return {
		id: G,
		stops: [
			{
				offset: 0,
				color: t,
				opacity: K
			},
			{
				offset: s,
				color: t,
				opacity: K
			},
			{
				offset: s,
				color: n,
				opacity: K
			},
			{
				offset: 1,
				color: n,
				opacity: K
			}
		]
	};
}
var J = {
	top: 4,
	right: 3,
	bottom: 4,
	left: 3
}, Y = 18, X = 18;
function Z(e, t) {
	let n = e.filter((e) => !t.includes(e.series)), r = e.filter((e) => t.includes(e.series));
	return [...n.length ? [m(n, {
		...E,
		strokeWidth: 2,
		curve: N
	})] : [], ...r.length ? [m(r, {
		...E,
		strokeWidth: 2,
		strokeDasharray: "5 4",
		curve: N
	})] : []];
}
function Q(e, t) {
	let n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = [...e].sort((e, n) => t.indexOf(e.series) - t.indexOf(n.series));
	for (let e of i) {
		let t = e.x instanceof Date ? e.x.getTime() : e.x, i = r.get(t) ?? {
			above: 0,
			below: 0
		};
		e.value < 0 ? i.below += e.value : i.above += e.value, r.set(t, i), n.set(e, e.value < 0 ? i.below : i.above);
	}
	return (e) => n.get(e);
}
function ee(e, t) {
	let n = {
		...E,
		y: t
	};
	return [H(z(e, {
		...n,
		r: 6.25
	}), { match: "group" }), H(z(e, {
		...n,
		r: 3.75,
		fill: "var(--ts-chart-focus-fill, Canvas)"
	}), { match: "group" })];
}
function te(e, t) {
	let n = /* @__PURE__ */ new Map();
	for (let t of e) {
		let e = t.x instanceof Date ? t.x.getTime() : t.x, r = n.get(e);
		(!r || t.value > r.value) && n.set(e, t);
	}
	let r = new Set(n.values()), i = e.filter((e) => {
		let i = n.get(e.x instanceof Date ? e.x.getTime() : e.x);
		return r.has(e) || t(e.value) !== t(i.value);
	});
	return b(U(i, {
		...E,
		text: (e) => t(e.value),
		dy: (e) => r.has(e) ? -8 : 14,
		fontSize: 11
	}));
}
function $(e) {
	let t = [...new Set(e.map((e) => e.x instanceof Date ? e.x.getTime() : e.x))], n = t.every((e) => typeof e == "number"), r = n ? Math.min(...t) : 0, i = n ? Math.max(...t) : t.length - 1;
	return (e) => {
		let n = e instanceof Date ? e.getTime() : t.indexOf(e);
		return i > r ? (n - r) / (i - r) : 0;
	};
}
function ne(e, t) {
	let n = w.axis, r = Math.max(0, ...t.map((e) => e.value)), i = $(t);
	return [h(e, {
		x: "x",
		stroke: n,
		strokeDasharray: "3 3"
	}), b(U(e.map((e) => ({
		...e,
		y: r,
		end: i(e.x) > .5
	})), {
		x: "x",
		y: "y",
		text: "label",
		fill: n,
		fontSize: 11,
		anchor: (e) => e.end ? "end" : "start",
		dx: (e) => e.end ? -4 : 4
	}))];
}
function re(e, t = {}) {
	let { area: n = [], stacked: r = !1, dashed: i = [], guides: a = !0, labels: o = !1, markers: s = [], grouped: c = !1 } = t, { format: l = M, xFormat: u, valueLabel: d, colors: f, legend: h, tooltip: _ = !0, margin: x, xPadding: S, yAxis: A, highlight: F, threshold: I, edges: L } = t, R = k(e), z = L && !r && L.before.length > 0 && L.after.length > 0 ? L : void 0, B = z ? [
		...z.before,
		...e,
		...z.after
	] : e, V = B.filter((e) => n.includes(e.series)), H = r || V.length > 0, U = x ?? (a ? void 0 : J), K = o && U ? {
		...U,
		top: Math.max(U.top ?? 0, X),
		bottom: Math.max(U.bottom ?? 0, Y)
	} : U, $ = r ? [P(e, {
		...E,
		layout: v({ order: R }),
		fillOpacity: .85,
		curve: N
	})] : [...V.length ? [b(P(V, {
		...E,
		curve: N,
		...I ? {
			fill: `url(#${G})`,
			fillOpacity: 1
		} : { fillOpacity: .12 }
	}))] : [], ...z ? [...Z(B, i).map((e) => b(e)), m(e, {
		...E,
		strokeOpacity: 0,
		curve: N
	})] : Z(e, i)];
	return g({
		theme: C,
		guides: a,
		margin: K,
		...I && V.length ? { gradients: [q(I, V)] } : {},
		marks: [
			...$,
			...o && !r ? [te(e, l)] : [],
			...s.length && !r ? ne(s, e) : [],
			...H ? [p([0])] : [],
			...c ? [y({
				x: !0,
				y: !1,
				stroke: w.axis,
				strokeDasharray: "3 3"
			})] : [],
			...c ? ee(e, r ? Q(e, R) : "value") : []
		],
		scales: {
			x: j(B, "point", u, z ? -.5 : S),
			y: D(l, d, A)
		},
		color: O(R, f, (h ?? !0) && a, F),
		...c ? {
			focus: "group-x",
			maxFocusDistance: Infinity
		} : {},
		...c ? { focusRing: !1 } : {},
		tooltip: _ ? c ? T(e, l, u, ["right", "left"]) : W(e, l, u) : void 0
	});
}
export { P as n, re as t };

//# sourceMappingURL=line-BNF2PSKe.js.map